import { useQuery } from '@hooks/reactQuery';

import { getAssetCartRequestDropdowns } from '@api/assetCartRequest';

import {
	optionsFormattedAssetSubType,
	optionsFormattedAssetType,
	optionsFormattedWithIdName,
} from '@utils/formatter';

import { refetchOptions } from '@constants/common';
import { ASSET_CART_REQUEST_DROPDOWN } from '@constants/queryKeys';

export const useQueryAssetCartRequestOptions = () => {
	const { data } = useQuery({
		queryKey: [ASSET_CART_REQUEST_DROPDOWN],
		queryFn: getAssetCartRequestDropdowns,
		...refetchOptions,
	});

	const {
		owners = [],
		assetTypes = [],
		assetSubTypes = [],
	} = data || {};

	return {
		ownersOptions: optionsFormattedWithIdName(owners) || [],
		assetTypesOptions: optionsFormattedAssetType(assetTypes) || [],
		assetSubTypesOptions: optionsFormattedAssetSubType(assetSubTypes) || [],
	};
};
